import { useEffect, useState } from 'react';

interface Props {
  onScrollIntoView: () => void;
  text: string;
  useTypewriterEffect?: boolean;
}

const ProfileCompetencyMappingChatText = ({
  onScrollIntoView,
  text,
  useTypewriterEffect
}: Props) => {
  const [displayedText, setDisplayedText] = useState<string>(
    useTypewriterEffect ? '' : text
  );

  useEffect(() => {
    if (!useTypewriterEffect) return;

    const chunkSize = 3;

    let i = 0;

    const tick = () => {
      setDisplayedText(text.slice(0, i));
      i += chunkSize;

      if (i <= text.length) {
        const char = text[i];
        let delay = 10 + Math.random() * 20;

        if (['.', '!', '?'].includes(char)) delay += 80;

        setTimeout(tick, delay);
      } else {
        setDisplayedText(text);
      }

      onScrollIntoView();
    };

    tick();
  }, []);

  return <div className="message">{displayedText}</div>;
};

export default ProfileCompetencyMappingChatText;
